(function($) {
    $(function() {
        // Add css classes for external links.
        $("a:not(.no-icon)").each(function() {
            var cssClass = '';
            var src;
            if ($(this).attr('target') == '_blank') cssClass = 'ext ';
            href = $(this).attr('href');
            if (href) cssClass = cssClass + href.substr( (href.lastIndexOf('.') +1) );
            if ($(this).children(".icon").length > 0) $(this).children(".icon").addClass(cssClass);
            else if ($(this).children().length == 1) $(this).children().addClass(cssClass);
            else $(this).addClass(cssClass);
        });
    });
} )( jQuery );